import { render, staticRenderFns } from "./LightsBackground.vue?vue&type=template&id=8ec4ab2a&scoped=true&"
import script from "./LightsBackground.vue?vue&type=script&lang=js&"
export * from "./LightsBackground.vue?vue&type=script&lang=js&"
import style0 from "./LightsBackground.vue?vue&type=style&index=0&id=8ec4ab2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec4ab2a",
  null
  
)

export default component.exports